import { render, staticRenderFns } from "./rss.svg?vue&type=template&id=738ace0c"
var script = {}


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports